module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-card"],
    style: _vm._cardStyle
  }, [_c('div', {
    staticClass: ["dof-card-header"],
    style: _vm._cardWrapperStyle,
    on: {
      "click": _vm.onSelect
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: ["dof-card-header-tag"],
    style: {
      backgroundColor: _vm._tagBg
    }
  }, [_c('image', {
    class: [_vm._isColmo ? 'dof-card-header-tag-confirm-colmo' : 'dof-card-header-tag-confirm'],
    attrs: {
      "src": _vm._isColmo ? _vm.confirm.colmo : _vm.confirm.default
    }
  })]) : _vm._e(), _c('div', {
    staticClass: ["dof-card-header-content"]
  }, [_vm._t("default")], 2), (_vm.collapsable) ? _c('div', {
    staticClass: ["dof-card-header-arrow-wrapper"],
    on: {
      "click": _vm.onCollapse
    }
  }, [(_vm._isColmo) ? _c('dof-switch', {
    attrs: {
      "checked": !_vm.collapsed_
    },
    on: {
      "dofChange": _vm.onCollapse
    }
  }) : _c('image', {
    ref: "arrow",
    staticClass: ["dof-card-header-arrow"],
    attrs: {
      "src": _vm.arrowUp
    }
  })], 1) : _vm._e()]), (_vm.collapsable) ? _c('div', {
    ref: "body",
    staticClass: ["dof-card-body"]
  }, [_vm._t("body")], 2) : _vm._e(), (_vm.dotConfig.normalColor && _vm.dotConfig.clickedColor) ? _c('div', {
    staticClass: ["dof-card-dot"],
    style: {
      backgroundColor: _vm.clicked_ ? _vm.dotConfig.clickedColor : _vm.dotConfig.normalColor
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-8bfc90ae!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-card/index.vue
// module id = 642
// module chunks = 0 1